import { matchingUsers } from '../utils/messaging/user';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import ContactListItem from './contact-list-item.gjs';

export default class ConversationMemberListItem extends Component {
  @service intl;
  @service messaging;

  get member() {
    return this.args.member;
  }

  get contact() {
    return {
      id: this.member.id,
      members: [this.member],
      isClient: this.member.isClient,
    };
  }

  get isCurrentUser() {
    return matchingUsers(this.member, this.messaging.currentProfile.user);
  }

  get nameSuffix() {
    return this.isCurrentUser ? this.intl.t('emc.conversation_details.you') : '';
  }

  get showAwayIndicator() {
    if (!this.messaging.currentProfile.isClient) {
      return false;
    }

    return this.member.isAway === true && this.member.isClinician;
  }

  get showScopeIndicator() {
    return this.messaging.currentProfile.isClinician && this.member.isClient;
  }

  <template>
    <ContactListItem
      @contact={{this.contact}}
      @nameSuffix={{this.nameSuffix}}
      @onNameClick={{@onNameClick}}
      @showAwayIndicator={{this.showAwayIndicator}}
      @showScopeIndicator={{this.showScopeIndicator}}
      data-test-conversation-member-list-item
    />
  </template>
}
